var exports = {
  "uW": "SettingsSection.module__section___SkxVZ3",
  "bV": "SettingsSection.module__sectionHeader___SkxVZ3",
  "Uj": "SettingsSection.module__sectionHeaderWithActions___SkxVZ3",
  "Yc": "SettingsSection.module__sectionHeaderText___SkxVZ3",
  "sq": "SettingsSection.module__sectionTitleRow___SkxVZ3",
  "vO": "SettingsSection.module__sectionActions___SkxVZ3",
  "N1": "SettingsSection.module__subsectionActions___SkxVZ3",
  "Gf": "SettingsSection.module__sectionTitle___SkxVZ3",
  "yV": "SettingsSection.module__sectionDescription___SkxVZ3",
  "f5": "SettingsSection.module__sectionContent___SkxVZ3",
  "t8": "SettingsSection.module__subsectionHeader___SkxVZ3",
  "Wf": "SettingsSection.module__subsectionTitle___SkxVZ3",
  "Yq": "SettingsSection.module__subsectionDescription___SkxVZ3",
  "No": "SettingsSection.module__subsectionContent___SkxVZ3",
};

module.exports = exports;
